export class IntroEligibility {
    constructor(status) {
        this.status = status;
    }
}
//# sourceMappingURL=IntroEligibility.js.map